import BaseContainer from './BaseContainer';
const DefaultTabContainer = BaseContainer.create();

// This container is used for ease of tracking if the default tab opened is the activities tab through getMeasureOptions
export default DefaultTabContainer;